<template>
  <div v-show="showPresent" class="present-container">
    <ui-modal
      :show="showPresent"
      type="tag"
      title="赠送礼物"
      iconType="remind"
      :decorate="false"
      @clickTitle="handleClickShowTip"
      @close="showPresent = false"
    >
      <div class="bg-popup"></div>
      <template #header-right>
        <div class="present-herder">
          余额<i class="match"></i
          >{{
            amount.quizRemainNum > 999999
              ? '999999'
              : amount.quizRemainNum
          }}
          <i class="coins"></i>{{ amount.matchRemainNum }}
        </div>
      </template>
      <div class="present">
        <div class="inner">
          <div class="left-box">
            <div class="icon">
              <div
                class="head"
                :style="{ 'background-image': `url(${team.avatar})` }"
              ></div>
              <div class="frame"></div>
            </div>
            <div class="name">
              <div class="label-box">
                <div class="label-shadow">{{ team.name }}</div>
                <div class="label-text">{{ team.name }}</div>
              </div>
            </div>
          </div>
          <div class="right-box" v-if="filteredPresentList.length">
            <div
              v-for="(item, index) in filteredPresentList"
              :key="index"
              :class="['souvenirs', { active: index === selectedSouvenirIndex }]"
              @click="handleClick(item, index)"
            >
              <div class="bg">
                <div class="default"></div>
                <div class="active"></div>
              </div>
              <div class="product" :style="{ backgroundImage: `url(${item.url})` }"></div>
              <div class="tips">
                <i></i>
                <div class="label-box">
                  <div class="label-shadow">人气值+{{ item.popularity }}</div>
                  <div class="label-text">人气值+{{ item.popularity }}</div>
                </div>
                <i></i>
                <!-- {{
                  characterSum >= 10000
                    ? (characterSum / 10000).toFixed(2) + '万'
                    : characterSum
                }} -->
              </div>
              <div v-if="index === 0" class="coins">
                <i :style="{ 'background-image': `url(${iconUrl[index]})` }"></i>
                <div class="label-box">
                  <div class="label-shadow">100</div>
                  <div class="label-text">100</div>
                </div>
              </div>
              <div v-else class="coins">
                <div class="label-box">
                  <div class="label-shadow">拥有: {{ item.count }}</div>
                  <div class="label-text">拥有: {{ item.count }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div>{{ this.filteredPresentList[0] }}</div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="left-box">
          <div class="consume" v-if="selectedTab === 'give'">
            <!-- 判断是否是第一个 -->
            <div class="label-box">
              <div class="label-shadow">消耗</div>
              <div class="label-text">消耗</div>
            </div>
            <i :style="{ 'background-image': `url(${iconUrl[selectedSouvenirIndex]})` }"></i>
            <div class="label-box">
              <div class="label-shadow">{{ giftID === 'xc003' ? 100 * consumeSum : consumeSum }}</div>
              <div class="label-text">{{ giftID === 'xc003' ? 100 * consumeSum : consumeSum }}</div>
            </div>
          </div>
          <div class="consume" v-else></div>
          <div class="character">
            <div class="label-box">
              <div class="label-shadow">人气值+<span>{{ characterSum }}</span></div>
              <div class="label-text">人气值+<span>{{ characterSum }}</span></div>
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="amount-surplus">
            <i class="del" @click="decreaseValue"></i>
            <div class="counts">
              <div class="label-box">
                <div class="label-shadow">{{ initalValue }}</div>
                <div class="label-text">{{ initalValue }}</div>
              </div>
            </div>
            <i class="add" @click="increaseValue"></i>
          </div>
          <ui-frame-bg class="betting-btn" colorType="yellow" @click.native="handleClickGive">
            <div class="label-box">
              <span class="label-shadow">赠礼</span>
              <span class="label-text">赠礼</span>
            </div>
          </ui-frame-bg>
        </div>
      </div>
      <!-- 点击提醒 tip -->
      <div v-if="showPopup" class="popup">
        <div class="popup-content">
          <span>
            赠送礼物可以给战队增加人气值，同时个人可以获得贡献值，战队人气值等于个人贡献值
          </span>
        </div>
      </div>
      <Prompt ref="prompt"></Prompt>
      <ShowTost ref="toast"></ShowTost>
    </ui-modal>
    <ui-modal-confirm ref="confirmed" :options="comfirmOptions" style="height: 100%;" @apply="Confirmationofgift" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as api from '@/service/index'
import UiModal from '@/components/ui-modal.vue'
import UiFrameBg from '@/components/ui-frame-bg.vue'
import Prompt from '@/components/prompt'
import ShowTost from '@/components/toast'
import UiModalConfirm from '@/components/ui-modal-confirm'
export default {
  components: {
    UiModal,
    UiFrameBg,
    Prompt,
    ShowTost,
    UiModalConfirm
  },

  data() {
    return {
      // 控制弹框
      showPresent: false,
      // 战队信息
      team: {},
      // 背景颜色控制
      selectedSouvenirIndex: 0,
      // 控制tip
      showPopup: false,
      // 状态锁
      disableClick: false,
      // 初始值
      initalValue: 0,
      consume: 0,
      consumeSum: 0,
      character: 0,
      characterSum: 0,
      teamCode: 0,
      giftID: 0,
      desiredObject: null,
      clickPresent: null,
      dataBase: {},
      selectedTab: 'give',
      cachedPresentList: [],
      presentList: [],
      count: 1,
      iconUrl: [
        'https://website.xdcdn.net/module/sausage-match/images/quiz/coin.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde8Tdms.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6ebWO.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6eyza.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6eByy.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6eMy7.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6eriU.png',
        'https://website.xdcdn.net/poster/58881/2024_EventsCentre/Fde6emG8.png'
      ],
      urlIndex: 0,
      comfirmOptions: {
        tip: '您确定要赠送该礼物么？',
        cancel: {
          label: '返回',
          colorType: 'blue'
        },
        apply: {
          label: '确认',
          colorType: 'yellow'
        }
      }
    }
  },
  computed: {
    ...mapState(['amount', 'token']),

    // 设置初始值
    // 赠礼

    filteredPresentList() {
      // return this.selectedTab === 'back'
      //   ? this.cachedPresentList
      //   : this.presentList
      return this.presentList
    }
  },
  watch: {
    initalValue() {
      // 监听 initalValue 变化，更新消耗和人气值
      this.updateValues()
    },
    selectedTab(newValue) {
      // console.log('newValue',newValue)
      // console.log('newValue')
      if (newValue === 'back') {
        // 当切换到 'back' 选项卡并且缓存的数据为空时，才请求接口获取数据
        this.fetchPresentList()
      } else {
        const defaultInitData = this.presentList[0]
        const { coins, popularity, giftId } = defaultInitData
        this.selectedSouvenirIndex = 0
        this.consume = coins
        this.character = popularity
        this.initalValue = 1
        this.consumeSum = coins
        this.characterSum = popularity
        this.giftID = giftId
      }
    }
  },
  methods: {
    ...mapActions(['reqUserInfo']),
    openPresent(item, res) {
      // console.log('res',res)
      // console.log('item1111',item,)
      this.team = item
      this.showPresent = true
      this.presentList = res
      if(!item || !res) return;
      // 默认第一个
      const defaultInitData = this.presentList[0]
      const { popularity, giftId } = defaultInitData
      this.selectedSouvenirIndex = 0
      // this.consume = coins
      this.character = popularity
      this.initalValue = 0
      // this.consumeSum = coins
      this.characterSum = popularity
      this.giftID = giftId
      this.count = res[0].count
      this.teamCode = item.teamCode
      this.selectedTab = 'give'
    },

    // 选中
    handleClick(item, index) {
      if (this.selectedSouvenirIndex === index) {
        return
      } else {
        // 当前的商品信息
        // console.log('item',item)
        const { popularity = 0 } = item
        this.consume = 0
        this.character = popularity
        this.initalValue = 0
        this.count = item.count
        this.giftID = item.giftId
        this.selectedSouvenirIndex = index
        this.updateValues()
      }
    },

    updateValues() {
      this.consumeSum = this.initalValue
      this.characterSum = this.character * this.initalValue
    },
    increaseValue() {
      if (this.initalValue < this.count && this.count != 0) {
        this.initalValue++
        this.updateValues()
      } else {
        const message =
          this.selectedSouvenirIndex === 0
            ? '货币数量不足，请重新选择'
            : '礼物数量不足，请重新选择'
        this.$refs.toast.showToast(message, 800)
      }
    },
    decreaseValue() {
      if (this.count == 0) {
        const message =
          this.selectedSouvenirIndex === 0
            ? '货币数量不足，请重新选择'
            : '礼物数量不足，请重新选择'
        this.$refs.toast.showToast(message, 800)
        return
      }
      if (this.count >= this.initalValue && this.initalValue > 0) {
        this.initalValue--
        this.updateValues()
      } else {
        this.$refs.toast.showToast('请选择礼物进行赠送', 800)
      }
    },

    handleClickShowTip() {
      this.showPopup = true

      setTimeout(() => {
        this.showPopup = false
      }, 1200)
    },
    findObjectById(data, id) {
      return data.find((obj) => obj.giftId === id)
    },

    async handleClickGive() {
      // 如果是第一个礼物，就判断赛事币，否则就是存量

      // 判断存量了
      const quite = this.count != 0 && this.count >= this.initalValue
      if (quite) {
        if(this.initalValue >= 1) {
          this.$refs.confirmed.showModal()
        } else {
          this.$refs.toast.showToast('请选择赠送的礼物数量', 1200)
        }
      } else {
        this.$refs.toast.showToast('礼物不足,参与活动可以获得礼物', 1200)
      }
    },
    // 确认赠送
    async Confirmationofgift() {
      try {
        let data = {
          giftId: this.giftID,
          count: this.initalValue,
          teamCode: this.teamCode,
          force: true
        }
        if(!this.token) return;
        const res = await api.directPresentGift(this.token, data)
        // console.log('res', res)
        if (res.status === 200) {
          // console.log('强刷商品列表,',this.selectedSouvenirIndex)
          if (this.selectedSouvenirIndex == 0) {
            // 扣除 赛事币
            this.reqUserInfo(true)

            if (typeof tapdb == 'undefined') return
            // 当前消耗的竞猜币
            tapdb.trackEvent('赠送比心', {
              '#value_change': this.initalValue * 100,
              '#value_after': this.amount.quizRemainNum,
              '#coin_id': 'xc001',
              '#via_type': '比心由竞猜币兑换获得',
              '#team_id': this.teamCode,
              '#value_hot': this.characterSum
            })
          } else {
            // 强刷商品列表
            if(!this.token) return;
            const res = await api.reqGiftList({
              token: this.token,
              force: true
            })
            if (res.status === 200) {
              res.data.find((item) => {
                // TODO  数据BUG
                // if (item.giftId == this.giftID) {
                //   if (typeof tapdb == 'undefined') return
                //   tapdb.trackEvent('赠送礼物', {
                //     '#item_gain': this.initalValue,
                //     '#prop_after': item.coins,
                //     '#prop_id': this.giftID,
                //     '#via_type': '赠送礼物',
                //     '#team_id': this.teamCode,
                //     '#value_hot': this.characterSum
                //   })
                // }
              })
            }
          }
          this.$refs.toast.showToast('赠送成功', 1000)
          setTimeout(() => {
            this.showPresent = false
          }, 1000)
        } else {
          this.$refs.toast.showToast('赠送失败,请稍后尝试', 800)
        }
      } catch (err) {
        console.log('err', err)
      }
    },

    async fetchPresentList() {
      try {
        // 请求接口获取数据
        if(!this.token) return;
        const req = await api.getBackpackData(this.token)
        if (req.status === 200) {
          // console.log('res', req)
          this.cachedPresentList = req.data

          const defaultInitData = this.cachedPresentList[0]
          if (defaultInitData) {
            const { coins, popularity, giftId } = defaultInitData
            this.selectedSouvenirIndex = 0
            this.consume = coins
            this.character = popularity
            this.initalValue = 1
            this.consumeSum = coins
            this.characterSum = popularity
            this.giftID = giftId
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  },

  created() {
    // this.reqUserInfo(true)
  }
}
</script>

<style lang="scss" scoped>
.present-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 60;
}
@import '~@/assets/scss/live/present.scss';
</style>